import styled, { css } from 'styled-components'

import { minmedia } from '../../../styles/media-queries'
import { black, white } from '../../../styles/colors'
import { DropDown } from '../AssortimentMenu/styles'
import { Dropdown } from '../../../styles/defaults-header'

export const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  background: ${white};
`

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative; // dropdown
  margin: 0 0.5rem;
  background: ${white};
  padding: 1.75rem 0;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }

  ${minmedia.xxlarge`
    margin: 0 1rem;
  `};
   ${props =>
      props.active &&
      css`
        ${DropDown},
        ${Dropdown} {
          transform: translateY(100%);
          opacity: 1;
        }
      `};
    & > a {
    font-size: 18px;
    color: ${black};
    text-decoration: none;
    cursor: pointer;
    position: relative;

    &::after {
      transition: all 0.5s;
      content: '';
      width: ${props => (props.current ? '70%' : '0')};
      position: absolute;
      height: 1px;
      background: ${black};
      left: 0;
      bottom: -0.5rem;
    }
    &:hover {
      &::after {
        width: 70%;
      }
    }
  }
`

export const IconContainer = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  position: relative;
  display: inline-block;
  margin-left: 0.5rem;
  svg {
    width: 0.75rem;
    height: 0.75rem;
    path {
      fill: ${black};
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Header/PageNav/styles.js